import { useEffect } from 'react';

const useHandleClickOutside = (refs, open, setOpen) => {
    useEffect(() => {
        if (!open) return;

        const handleClickOutside = (e) => {
            const clickedInside = refs.some((ref) => ref.current && ref.current.contains(e.target));

            if (!clickedInside) setOpen(false);
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open, refs, setOpen]);
};

export default useHandleClickOutside;
